/**
 * cityMaps — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const cityMapsPack: ToilePack = {
    slug: 'city-maps',
    category: 'citymap',
    name: 'City maps',
    tagline: tagline('map prints', 'cities', 'styles'),
    chips: chips('cities', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'newyork', label: 'New York', subject: 'the Manhattan grid between two rivers, the park, the east bridges'},
        {key: 'london', label: 'London', subject: 'the river bending through the centre, the radiating street web'},
        {key: 'tokyo', label: 'Tokyo', subject: 'the dense loop around the palace grounds, the bay to the south'},
    ],
    styles: [
        {key: 'line', label: 'Minimal line', style: 'minimal line map, hairline streets', palette: 'one ink, water as a flat tint', framing: 'city name on a title strip, no labels'},
        {key: 'watercolor', label: 'Watercolor', style: 'watercolor, loose wet washes over the streets', palette: 'blue and rust bleeding on white paper', framing: 'city name on a title strip, no labels'},
        {key: 'engraved', label: 'Vintage engraved', style: 'vintage engraved, hatched blocks and stippled water', palette: 'sepia ink on aged paper', framing: 'city name on a title strip, compass rose'},
    ],
    directions: ['Lisbon instead', 'in black on cream', 'zoomed to the old town'],
}
